import { NICHT_LESBAR } from '../../config/ebenen';

// F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.3 T-M): der Satz zum Schwärzen in drei Teilen, damit das Formular das Info-Symbol direkt
// hinter „Mandantendaten“ setzt. formular.schwaerzen bleibt derselbe ganze Satz für das Detail (TicketDetail.tsx).
const SCHWAERZEN = { vor: 'Bitte schwärzen Sie ', wort: 'Mandantendaten', nach: ' und andere vertrauliche Angaben, bevor Sie ein Bildschirmfoto anhängen.' } as const;

// Alle Wörter der Tickets der Person (Profil-Nachbau F-06, BAU-HILFE.md 1.5; TEIL-3 1.0, SP3-03 und SP3-04 „Soll Oberfläche“ mit
// den Ersetzungen aus BAU-HILFE 1.5; PF-310-1 Liste und Formular, PF-310-2 Detail). Tickets.tsx und TicketFormular.tsx nehmen
// jedes Wort von hier. Sätze, die auch der Server sendet, stehen gleichlautend in backend/src/support/texte.ts bzw. anhaenge.ts.
export const TICKET_TEXTE = {
  // TEIL-3 1.0, Kundenseite.
  status: {
    NEU: 'Eingegangen',
    IN_BEARBEITUNG: 'In Bearbeitung',
    WARTET_AUF_KUNDE: 'Wartet auf Ihre Antwort',
    GELOEST: 'Gelöst',
    GESCHLOSSEN: 'Geschlossen',
  },
  kategorie: {
    FEHLER: 'Etwas funktioniert nicht',
    ANTWORT_FALSCH: 'Falsche oder zweifelhafte Antwort',
    FRAGE: 'Frage zur Bedienung',
    KONTO: 'Konto und Zugang',
    ABRECHNUNG: 'Rechnung und Tarif',
    WUNSCH: 'Idee oder Wunsch',
    SONSTIGES: 'Sonstiges',
  },
  sicht: NICHT_LESBAR,
  // PF-316: Textlink unter einem Fehler der Recherche (pages/RISAssistant.tsx).
  problemMelden: 'Problem melden',
  // F-23 (PF-NB-hilfe-3): Link unter einer Antwort mit gespeicherter Bewertung „nicht hilfreich“ (components/AnswerRating.tsx).
  antwortMelden: 'Dem Support melden',
  // F-23 (PF-NB-hilfe-3, E-4): Namen der Seiten im Satz „Mitgeschickt werden …“; die übrigen Wörter aus config/ebenen.ts.
  seiten: { start: 'Startseite', recherche: 'Recherche', vorlagen: 'Vorlagen' },
  liste: {
    titel: 'Tickets',
    // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.2 U2): die Unterzeile erklärt das Wort „Tickets“.
    beschreibung: 'Ihre Anfragen an den Support mit Status und Antworten',
    neueAnfrage: 'Neue Anfrage',
    suche: 'Betreff, Text oder Referenz',
    // Name des Segments für Bildschirmleser.
    filter: 'Filter',
    offen: 'Offen',
    geschlossen: 'Geschlossen',
    alle: 'Alle',
    leer: 'Sie haben noch keine Anfragen gestellt.',
    leerGefiltert: 'Keine Anfrage passt zu Ihrer Auswahl.',
    laden: 'Tickets werden geladen …',
    fehler: 'Die Tickets sind gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
    erneutVersuchen: 'Erneut versuchen',
    weitere: 'Weitere laden',
    neueAntwort: 'Neue Antwort',
  },
  formular: {
    titel: 'Neue Anfrage an den Support',
    kategorie: 'Worum geht es?',
    wunschZeile: 'Wünsche sammeln wir gesondert, andere können dafür stimmen.',
    wunschEinreichen: 'Wunsch einreichen',
    antwortHinweis: 'Nennen Sie, was an der Antwort nicht stimmt, und wenn möglich die richtige Fundstelle.',
    // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.3 T-A): ohne Recherche der Tooltip „Erklärung: Antwort melden“ hinter dem Hinweis.
    antwortMeldenWort: 'Antwort melden',
    antwortOhneRecherche: 'Am schnellsten geht es direkt unter der Antwort: Daumen nach unten („Antwort nicht hilfreich“), dann „Dem Support melden“.',
    betreff: 'Betreff',
    betreffPlatzhalter: 'Zum Beispiel: Recherche bricht ab',
    beschreibung: 'Beschreibung',
    beschreibungPlatzhalter: 'Was haben Sie getan, was ist passiert, was haben Sie erwartet?',
    dateien: 'Bildschirmfotos oder Dateien',
    // F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.3 H1, T-D): der Feldhinweis mit höchstens 12 Wörtern, das Hineinziehen im Tooltip.
    dateienHinweis: 'Höchstens 3 Dateien je 10 MB: PNG, JPG, GIF, WebP, PDF, TXT, CSV',
    dateienTipp: 'Sie können Dateien auch hineinziehen oder mit Strg+V einfügen.',
    // K12-4 (static-brand-fonts.test.mjs): kein „Mandantinnen und Mandanten“ in sichtbaren Texten, nur „Mandantendaten“ (F-09);
    // der Tooltip dazu sagt deshalb „Klientschaft“ (F-24, SPEC-hilfe-b 3.3 T-M).
    schwaerzen: `${SCHWAERZEN.vor}${SCHWAERZEN.wort}${SCHWAERZEN.nach}`,
    schwaerzenTeile: SCHWAERZEN,
    mandantendatenTipp: 'Namen und Angaben Ihrer Klientschaft, also Ihrer Kundinnen und Kunden.',
    entfernen: 'Entfernen',
    sichtbarkeit: 'Wer darf diese Anfrage sehen?',
    sichtbarFirma: 'Der Support und die Verwaltung meiner Firma',
    sichtbarPrivat: 'Nur der Support und ich',
    verlaufZeile: 'Der Support sieht dann, was Sie schon gefragt haben.',
    rechercheHaken: 'Frage und Antwort dieser Recherche mitschicken',
    rechercheHinweis: 'Nur ankreuzen, wenn darin keine Mandantendaten stehen. Der Support sieht dann Ihre Frage und die Antwort.',
    recherchePrivat: 'Mit Frage und Antwort bleibt die Anfrage zwischen Ihnen und dem Support.',
    senden: 'Anfrage senden',
    abbrechen: 'Abbrechen',
    ansehen: 'Anfrage ansehen',
    laden: 'Der Entwurf wird geladen …',
    // Namen der Pflichtfelder in „Es fehlt noch: …“.
    fehlt: { kategorie: 'Kategorie', betreff: 'Betreff', beschreibung: 'Beschreibung' },
  },
  fehler: {
    betreffLaenge: '3 bis 150 Zeichen',
    beschreibungLaenge: '10 bis 10.000 Zeichen',
    steuerzeichen: 'Steuerzeichen sind nicht erlaubt.',
    dateityp: 'Dateityp nicht erlaubt. Erlaubt: PNG, JPG, GIF, WebP, PDF, TXT, CSV.',
    dateiGroesse: 'Die Datei ist größer als 10 MB.',
    // Wie backend/src/support/anhaenge.ts (Grenzen je Vorgang).
    dateienZahl: 'Höchstens 3 Dateien je Nachricht.',
    dateienGroesse: 'Die Dateien sind zusammen größer als 20 MB.',
    allgemein: 'Die Anfrage konnte nicht gesendet werden. Ihre Eingaben bleiben erhalten. Bitte versuchen Sie es erneut.',
  },
  // PF-310-2: Detail einer Anfrage (TEIL-3 SP3-04 „Detail“ mit den Ersetzungen aus BAU-HILFE 1.5, SP3-05 „Bezug zum Ticket“).
  detail: {
    zurueck: 'Zurück zu den Tickets',
    // Überschrift, solange es keinen Betreff gibt (Laden, Fehler, nicht sichtbar, Sicht).
    titel: 'Anfrage',
    laden: 'Anfrage wird geladen …',
    fehler: 'Die Anfrage ist gerade nicht erreichbar. Bitte versuchen Sie es in einigen Minuten erneut.',
    nichtSichtbar: 'Diese Anfrage gibt es nicht oder sie ist für Sie nicht sichtbar.',
    sichtbarFirma: 'Sichtbar für den Support und die Verwaltung Ihrer Firma',
    sichtbarPrivat: 'Nur für Sie und den Support',
    aendern: 'Ändern',
    speichern: 'Speichern',
    abbrechen: 'Abbrechen',
    stoerung: 'Zu dieser Anfrage gibt es eine bekannte Störung:',
    verlauf: 'Verlauf',
    sie: 'Sie',
    geloeschtesKonto: 'Gelöschtes Konto',
    // Erste Zeile eines angehängten Gesprächs, falls sein Text keine hat (backend/src/support/texte.ts, SYSTEMZEILEN.verlaufTitel).
    verlaufTitel: 'Gespräch mit dem Hilfe-Assistenten',
    herunterladen: 'Herunterladen',
    antwort: 'Ihre Antwort',
    antwortSenden: 'Antwort senden',
    antwortLaenge: '1 bis 10.000 Zeichen',
    antwortFehler: 'Die Antwort wurde nicht gesendet. Ihr Text bleibt erhalten.',
    erledigt: 'Ist Ihr Anliegen damit erledigt?',
    bestaetigen: 'Ja, Lösung bestätigen',
    bestehtWeiter: 'Nein, das Problem besteht weiter',
    wasFehlt: 'Was fehlt noch?',
    neueAnfrageBitte: 'Bitte stellen Sie eine neue Anfrage dazu.',
    geschlossen: 'Diese Anfrage ist geschlossen.',
    neueAnfrageDazu: 'Neue Anfrage dazu stellen',
    zurueckziehen: 'Anfrage zurückziehen',
    zurueckziehenFrage: 'Anfrage zurückziehen?',
    zurueckziehenText: 'Der Support bearbeitet sie dann nicht weiter. Sie bleibt unter „Geschlossen“ sichtbar.',
    zurueckziehenKnopf: 'Zurückziehen',
    bewertungTitel: 'Wie zufrieden sind Sie mit der Hilfe?',
    bewertungen: ['Sehr unzufrieden', 'Unzufrieden', 'Teils, teils', 'Zufrieden', 'Sehr zufrieden'],
    bewertungKommentar: 'Möchten Sie etwas dazu sagen?',
    bewertungSenden: 'Bewertung senden',
    bewertungDank: 'Danke für Ihre Bewertung.',
    // Ein Schritt (Bestätigen, Zurückziehen, Sichtbarkeit, Bewertung) scheiterte ohne Satz des Servers.
    schrittFehler: 'Das hat nicht geklappt. Bitte versuchen Sie es erneut.',
    // Namen der Pflichtfelder in „Es fehlt noch: …“.
    fehlt: { antwort: 'Ihre Antwort', wasFehlt: 'Was fehlt noch' },
  },
} as const;

export const gemeldetVon = (melder: string) => `Gemeldet von ${melder}`;
export const eingegangenAm = (datumZeit: string) => `Eingegangen am ${datumZeit}`;
/** TEIL-3 SP3-04; am null: nur der erste Satz. */
export const wartetSeit = (seit: string, am: string | null) =>
  `Der Support wartet seit ${seit} auf Ihre Antwort.${am ? ` Ohne Antwort schließen wir die Anfrage am ${am} als gelöst.` : ''}`;

/** BAU-HILFE 1.5: mit E-Mail nur, wenn die Person die Mail „Antwort vom Support“ eingeschaltet hat. */
export const erfolgMitMail = (referenz: string) => `Ihre Anfrage ${referenz} ist eingegangen. Wir antworten hier unter „Tickets“ und per E-Mail.`;
export const erfolgOhneMail = (referenz: string) => `Ihre Anfrage ${referenz} ist eingegangen. Wir antworten hier unter „Tickets“.`;
/** Beschriftung eines Pflichtfelds, wie Field in administration/components.tsx sie bildet. */
export const pflicht = (wort: string) => `${wort} (Pflicht)`;
export const verlaufHaken = (n: number) => `Verlauf des Chats anhängen (${n} Nachrichten)`;
export const folgeBetreff = (referenz: string) => `Folgeanfrage zu ${referenz}`;
export const zuletztAm = (datum: string) => `zuletzt ${datum}`;
export const gefolgtVon = (melder: string) => `Gefolgt · ${melder}`;
/** TEIL-3 SP3-03, F-23 (PF-NB-hilfe-3): seite ist der Name der Seite (ticketLogik.ts seitenName), null ohne Klammer; code null ohne
 *  Fehlercode; mitRecherche mit angehängter Recherche. */
export const mitgeschickt = (seite: string | null, code: string | null, produkt: string, mitRecherche = false) =>
  `Mitgeschickt werden: die Seite, auf der Sie waren${seite ? ` („${seite}“)` : ''}, ${code ? `der Fehlercode ${code}, ` : ''}und die Version von ${produkt}. ${mitRecherche ? 'Dazu Frage und Antwort der gewählten Recherche.' : 'Inhalte Ihrer Recherchen werden nicht mitgeschickt.'}`;
export const betreffZaehler = (n: number) => `${n} von 150 Zeichen`;
